
import { useTranslation } from "react-i18next"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"

export function TrainerProfile() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">{t("trainerView.profile.title")}</h2>

      <Card>
        <CardHeader>
          <CardTitle>{t("trainerView.profile.personalInfo")}</CardTitle>
          <CardDescription>{t("trainerView.profile.personalInfoDescription")}</CardDescription>
        </CardHeader>
        <CardContent>
          <form className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="name">{t("trainerView.profile.name")}</Label>
                <Input id="name" defaultValue="John Smith" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="email">{t("trainerView.profile.email")}</Label>
                <Input id="email" type="email" defaultValue="john.smith@thenotfit.com" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="phone">{t("trainerView.profile.phone")}</Label>
                <Input id="phone" defaultValue="+1 (555) 123-4567" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="specialization">{t("trainerView.profile.specialization")}</Label>
                <Input id="specialization" defaultValue="Strength Training, HIIT" />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="bio">{t("trainerView.profile.bio")}</Label>
              <Textarea
                id="bio"
                rows={4}
                defaultValue="Certified personal trainer with 5+ years of experience specializing in strength training and HIIT workouts. Passionate about helping clients achieve their fitness goals."
              />
            </div>
            <Button type="submit">{t("trainerView.profile.save")}</Button>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{t("trainerView.profile.availability")}</CardTitle>
          <CardDescription>{t("trainerView.profile.availabilityDescription")}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {/* Simplified availability settings */}
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="workdays">{t("trainerView.profile.workdays")}</Label>
                <Input id="workdays" defaultValue="Monday - Friday" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="workhours">{t("trainerView.profile.workHours")}</Label>
                <Input id="workhours" defaultValue="9:00 AM - 6:00 PM" />
              </div>
            </div>
            <Button>{t("trainerView.profile.saveAvailability")}</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
